<template>
    <dx-popup
        title="Выберите должностное лицо"
        :visible="true"
        :show-close-button="true"
        :show-title="true"
        :animation="{ value: false }"
        @hidden="onHidden"
    >
        <div class="flex justify-between h-80% gap-8">
            <div class="h-[85%z] w-[45%] overflow-y-auto">
                <local-tree-view
                    ref="treeViewRef"
                    class="responsible-tree-view"
                    :data-source="departmentsWithOfficialsKrEpl"
                    :meta="meta"
                    @item-click="onItemClick"
                    @itemSelectionChanged="onItemSelectionChanged"
                >
                    <template #item-template="{ data }">
                        <div class="flex items-center gap-2">
                            <img :src="getImgSrc(data)" />
                            {{ data.name }}
                        </div>
                    </template>
                    <template #toolbarItems>
                        <dx-button
                            icon="/infoenergo/assets/predpr.svg"
                            hint="Показывать свои/все подразделения"
                            class="searchbar-chooser"
                            :focus-state-enabled="false"
                            :styling-mode="buttonStyle"
                            :type="buttonType"
                            @click="onFilterButtonClick"
                        />
                    </template>
                </local-tree-view>
            </div>
            <div v-if="selectedDepartment" class="grow info-card h-[80%]">
                <div class="flex items-center gap-2">
                    <h5 class="info-header">Информация о подразделении</h5>
                </div>
                <dx-form :formData="selectedDepartment" :readOnly="true" class="custom-chooser">
                    <dx-group-item>
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="name"
                            :label="{ text: 'Наименование:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-group-item :col-count="2" :col-span="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="sname"
                            :label="{ text: 'Краткое наименование:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="status_name"
                            :label="{ text: 'Состояние:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-group-item :colCount="2" class="custom-chooser">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="ecls_name"
                            :label="{ text: 'Отношение к энергосистеме:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="separator_name"
                            :label="{ text: 'Уровень организации:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-group-item :colCount="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="tel"
                            :label="{ text: 'Телефон:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="email"
                            :label="{ text: 'Адрес электронной почты:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-group-item :colCount="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="kodp"
                            :label="{ text: 'ID:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                </dx-form>
            </div>
            <div v-if="selectedOfficial" class="grow info-card">
                <div class="flex items-center gap-2">
                    <h5 class="info-header">Информация о сотруднике</h5>
                </div>
                <dx-form :formData="selectedOfficial" :readOnly="true" class="custom-chooser">
                    <dx-group-item :col-count="2" :col-span="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="fio"
                            :label="{ text: 'ФИО:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="e_mail"
                            :label="{ text: 'Электронная почта:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-simple-item
                        cssClass="custom-simple-item"
                        data-field="department"
                        :label="{ text: 'Отдел:' }"
                        :editorOptions="{ readOnly: true }"
                    />
                    <dx-group-item :col-count="2" :col-span="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="namedolzh"
                            :label="{ text: 'Должность:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="name_fun"
                            :label="{ text: 'Должностная функция:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                    <dx-group-item :colCount="2">
                        <dx-simple-item
                            cssClass="custom-simple-item"
                            data-field="tel"
                            :label="{ text: 'Мобильный телефон:' }"
                            :editorOptions="{ readOnly: true }"
                        />
                    </dx-group-item>
                </dx-form>
            </div>
        </div>
        <dx-toolbar-item location="after" toolbar="bottom">
            <ai-button
                text="Выбрать"
                styling-mode="blue"
                class="chooser-button"
                @click="chooseUser"
                :disabled="disabled"
            />
        </dx-toolbar-item>

        <dx-toolbar-item location="after" toolbar="bottom">
            <ai-button
                text="Отмена"
                styling-mode="light-blue"
                class="chooser-button"
                style="margin-right: 10px"
                @click="hide"
            />
        </dx-toolbar-item>
    </dx-popup>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxPopup, DxForm } from 'devextreme-vue';
import { DxSimpleItem, DxGroupItem } from 'devextreme-vue/form';
import { dxUiNotify } from '@/utils/dx-helper';
import hideToasts from 'devextreme/ui/toast/hide_toasts';
import LocalTreeView from '@/components/local-tree-view.vue';
import usersLocalStore from '../../administration/users/store.js';
import { getNsiEmpCardData, getNsiOrgCardData } from '@/service/nsi-service';
import AiButton from '@/components/ai-button/ai-button.vue';
import { getDataSource } from '@/service/meta-service.js';

import usersStore from '@/store/administration/users';

const { usersState, setOfficialUserIds, fetchOfficialUserData, getDepartmentsWithOfficialsList } = usersStore;

const { state } = usersLocalStore;

import rolesStore from '@/store/administration/roles';

const { rolesState, getAreaListByAppKod } = rolesStore;

const selectedOfficial = ref(null);
const treeViewRef = ref();
const treeViewInstance = ref();
const disabled = ref(true);
const buttonType = ref('danger'); //danger - own, normal - all
const buttonStyle = ref('contain'); //contain - own, outlined - all
const kod_ecls = ref(1);
let isNotificationVisible = false;
const selectedDepartment = ref(null);
const grandParents = ref(new Map());
const parents = ref(new Map());
const childs = ref(new Map());
const chosenValueForEmit = ref(null);
const departmentsWithOfficialsKrEpl = ref([]);

const emit = defineEmits(['chooseUser', 'hiddenUserChooser']);

onMounted(async () => {
    treeViewInstance.value = treeViewRef.value.treeViewInstance;
    await getAreaListByAppKod(null);
    const response = await getDataSource(
        'admin./department/official/list/get',
        '{"meta_args": { "select": "payer.get_orgstructure_tree" }, "select_args": { "pr_hist_": false, "pr_es_": true }}'
    );
    departmentsWithOfficialsKrEpl.value = response.data;
    processDepartments(departmentsWithOfficialsKrEpl.value);
});

const onFilterButtonClick = async () => {
    buttonType.value = buttonType.value === 'danger' ? 'normal' : 'danger';
    buttonStyle.value = buttonStyle.value === 'contain' ? 'outlined' : 'contain';
    kod_ecls.value = kod_ecls.value === 1 ? 0 : 1;
    await getDepartmentsWithOfficialsList(kod_ecls.value);
};

const hasGrandparent = parentId => {
    const parent = usersState.departmentsWithOfficialsList.find(item => item.key === parentId);

    if (parent && parent.parent_id) {
        const grandparent = usersState.departmentsWithOfficialsList.find(item => item.key === parent.parent_id);
        return grandparent !== undefined;
    }

    return false;
};

const processDepartments = async data => {
    data.forEach(item => {
        if (item.parent_id === null) {
            grandParents.value.set(item.parent_id, item);
            item.img = '/infoenergo/assets/predpr.svg';
        } else if (grandParents.value.get(item.parent_id)) {
            parents.value.set(item.parent_id, item);
            item.img = '/infoenergo/assets/dep.svg';
        } else if (item.parent_id !== null && parents.value.get(item.parent_id)) {
            childs.value.set(item.parent_id, item);
            item.img = '/infoenergo/assets/filial.svg';
        } else {
            item.img = '/infoenergo/assets/new_user.svg';
        }
    });
};

const getImgSrc = data => {
    if (data.parent_id === null) {
        return '/infoenergo/assets/predpr.svg';
    }
    if (data.parent_id !== null && data.type === 'd') {
        if (hasGrandparent(data.parent_id)) {
            return '/infoenergo/assets/filial.svg';
        } else {
            return '/infoenergo/assets/dep.svg';
        }
    }
    if (data.type === 'e') {
        return '/infoenergo/assets/new_user.svg';
    }
};

const onItemClick = ({ itemData }) => {
    if (itemData.type === 'e') {
        setOfficial(itemData.id, itemData.parent_id);
        selectedDepartment.value = null;
    } else if (itemData.type === 'd') {
        setDepartment(itemData.id, itemData.parent_id);
        selectedOfficial.value = null;
    }
    disabled.value = false;
};

let repeatCounter = 0;
const chosenValueRef = ref(null);

const onItemSelectionChanged = changedValue => {
    if (changedValue.value === chosenValueRef.value) {
        repeatCounter++;
        disabled.value = true;
        if (repeatCounter === 2) {
            disabled.value = false;
            selectedDepartment.value = null;
            selectedOfficial.value = null;
            repeatCounter = 0;
        }
    } else {
        chosenValueRef.value = changedValue.value;
        disabled.value = false;
    }
};

const showNotification = (message, type, duration) => {
    if (isNotificationVisible) {
        hideToasts();
        isNotificationVisible = false;
    }

    if (!isNotificationVisible) {
        dxUiNotify(message, type, duration);
        isNotificationVisible = true;

        setTimeout(() => {
            isNotificationVisible = false;
        }, duration);
    }
};

const setDepartment = async (id, parent_id) => {
    if (selectedDepartment.value?.kodp !== id) {
        const formattedParentId = parseInt(parent_id?.substring(0, parent_id.length - 2));
        selectedDepartment.value = (await getNsiOrgCardData(id, formattedParentId)).data;
    } else {
        selectedDepartment.value = null;
    }
};

const setOfficial = async (id, parent_id) => {
    if (selectedOfficial.value?.official_id !== id) {
        setOfficialUserIds(id);
        const formattedParentId = parseInt(parent_id.substring(0, parent_id.length - 2));
        const response = await getNsiEmpCardData(id, formattedParentId);

        const department = response.data.path.replace(/\s*\\\s*.*$/, '').trim();

        await fetchOfficialUserData();
        const newUserGroupArea = rolesState.areaListByAppKod.map(area => {
            return {
                group_id: area.id,
                departments: null,
            };
        });
        state.userRequestBody = {
            fio: response.data.fio,
            e_mail: response.data.e_mail,
            namedolzh: response.data.namedolzh,
            name_fun: response.data.name_fun,
            tel: response.data.tel,
            department: department,
            id: null,
            official_id: id,
            locked_since: null,
            locked_until: null,
            lock_reason: '',
            user_type_id: 1,
            notification_email: false,
            notification_push: false,
            data_rights: newUserGroupArea,
        };
        if (!state.userRequestBody.department_rights) {
            state.userRequestBody.department_rights = [];
        }
        if (!usersState.officialUserData.e_mail) {
            showNotification(
                'Выбранного пользователя невозможно будет сохранить из-за отсутствия данных об адресе электронной почты',
                'warning',
                4000
            );
        } else {
            isNotificationVisible = false;
            hideToasts();
        }
        selectedOfficial.value = { ...state.userRequestBody };
    } else {
        selectedOfficial.value = null;
    }
};

const chooseUser = () => {
    chosenValueForEmit.value = selectedOfficial.value ? selectedOfficial.value : selectedDepartment.value;
    disabled.value = chosenValueForEmit.value ? true : false;
    emit('chooseUser', chosenValueForEmit.value);
    state.userCardPopupVisible = true;
    state.officialPopupVisible = false;
    blurClearAndUnselect();
};

const hide = () => {
    emit('hiddenUserChooser', false);
    state.officialPopupVisible = false;
    state.userRequestBody = {};
    blurClearAndUnselect();
};

const onHidden = () => {
    emit('hiddenUserChooser', false);
    blurClearAndUnselect();
};

const blurClearAndUnselect = () => {
    selectedOfficial.value = null;
    treeViewInstance.value.collapseAll();
    treeViewInstance.value.unselectAll();
    treeViewRef.value.textBoxValue = '';
};

const meta = {
    searchHint: null,
    valueChangeEvent: 'keyup',
    keyExpr: 'key',
    displayExpr: 'name',
    parentIdExpr: 'parent_id',
    rootValue: null,
    dataScructure: 'plain',
    selectByClick: true,
    expandEvent: 'dblclick',
    selectionMode: 'single',
    itemTemplate: 'item-template',
};
</script>
<style lang="scss">
.custom-chooser {
    .custom-simple-item {
        margin-top: -10px;
        margin-bottom: 5px;

        .dx-texteditor.dx-editor-filled {
            border-radius: 8px;
        }
    }
}

.responsible-tree-view {
    .search-bar {
        background: #ffffff;
        margin-bottom: 8px;
        border: 1px #03142533 solid;
        border-radius: 1px;
    }
    .dx-treeview-item {
        margin-bottom: 8px;
        background: #f6fafe;
        border-radius: 5px;
    }

    .dx-treeview-item:hover {
        border-radius: 5px;
        background: #f2f2f2;
    }
    .dx-treeview-item-without-checkbox.dx-state-focused > .dx-treeview-item {
        border-radius: 5px;
    }
    .dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item {
        background: #c1dfff;
        border-radius: 5px;
    }
    :deep(.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened::before) {
        display: flex;
        align-items: center;
    }

    :deep(.dx-treeview-toggle-item-visibility::before) {
        display: flex;
        align-items: center;
    }
}
.info-card {
    margin-top: 43px;
    background: #f6fafe;
    height: fit-content;
    border-radius: 15px;
    padding: 20px;
}

.info-header {
    font-weight: 500 !important;
    font-size: 18px !important;
    padding-bottom: 10px;
}

:deep(.dx-texteditor-input) {
    border-radius: 5px;
}

:deep(.dx-popup-content) {
    padding: 20px;
}

.chooser-button {
    margin-top: -50px;
}

.dx-field-item-label-text {
    font-size: 13px;
    margin-top: 16px;
    margin-left: -10px;
    color: #031425;
    font-weight: 400;
    white-space: nowrap;
}

:deep(.dx-field-item-label-location-top) {
    margin-left: 0;
    padding: 0;
}

:deep(.dx-popup-content.dx-popup-content-scrollable) {
    height: 85% !important;
}

.dx-button.dx-button-danger {
    background-color: #dbd9d9;
}
</style>
